import { Button, Stack, SvgIcon } from "@mui/joy";
import { motion } from "framer-motion";
import { memo } from "react";
import { DownArrowSvg } from "static/image/common/SvgAssets";
import { extractHexColor } from "styles/hexOpacity";
import { theme } from "styles/theme";

function GoNextBlockButton({
  highlight,
  disabled,
  onClick,
}: {
  highlight?: boolean;
  disabled: boolean;
  onClick: () => void;
}) {
  const activatedColor = extractHexColor(theme.vars.palette.Content.Highlight);

  const shouldAnimate = highlight && !disabled;

  if (disabled) return <></>;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ease: "easeInOut", duration: 0.3 }}
    >
      <Button
        size={"lg"}
        disabled={disabled}
        onClick={onClick}
        variant={"Plain"}
        sx={{
          width: "100%",
          minHeight: "46px",
          backgroundColor: "transparent",
          mt: 1,
        }}
      >
        <motion.div
          animate={{
            opacity: shouldAnimate ? [1, 0, 1] : 1,
          }}
          transition={{
            delay: 1,
            duration: shouldAnimate ? 1.8 : 0,
            repeat: shouldAnimate ? Infinity : 0,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <SvgIcon
              sx={{
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              inheritViewBox
            >
              <DownArrowSvg color={activatedColor} />
            </SvgIcon>
          </Stack>
        </motion.div>
      </Button>
    </motion.div>
  );
}

export default memo(GoNextBlockButton);
